/**
 * モジュール読み込み
 */
import '../js/main';
import './modules/angularjs/angular-app';
import { Execution } from './modules/utility/Decorator';
import { IframeWrap } from './modules/utility/IframeWrap';
import { Inview } from './modules/animation/Inview';
import { Lazyload } from './modules/async/Lazyload';
import { ModalPopup } from './modules/widget/ModalPopup';
import { PageScroll } from './modules/scroll/PageScroll';
import { Tab } from './modules/widget/Tab';
import { Accordion } from './modules/utility/Accordion';
import { FileSelect } from './modules/utility/FileSelect';
import { ContactWrap } from './modules/utility/ContactWrap';

import { Contact } from './modules/utility/Contact';

// グローバル参照
declare const create_masonry: any;

/**
 * 実行クラス
 */
@Execution()
class Main {

  /**
   * コンストラクタ
   */
  constructor() {
    /**
     * Lazyload
     */
    const lazyload: Lazyload = new Lazyload('.lazyload');
    lazyload.loadImages((): void => {
      create_masonry();
    });

    /**
     * inview
     */
    new Inview('.fn-inview', 0);

    /**
     * モーダル
     */
    new ModalPopup('.fn-modalPopup');

    /**
     * タブ
     */
    new Tab('.fn-tab');

    /**
     * エントリーページ ドロップダウンメニュー
     */
    new Accordion('.wpcf7-select');

    /**
     * エントリーページ ファイル名出力
     */
    new FileSelect('.wpcf7-file');

    /**
     * エントリーページ チェックボックス ラジオボタン labelでwrap
     */
    new ContactWrap();

    /**
     * ページをまたいだアンカーリンク
     */
    new PageScroll('.fn-header');

    //test
    new Contact();

    /**
     * iframeをタグで囲む（レスポンシブ対応）
     */
    new IframeWrap('.fn-iframeWrap');
  }

}
